
import { ICaseDetail,ids } from "./caseTypes";
import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

class CaseService {
    async page(searchVo: ICaseDetail) {
        const apiUrl = "/web/case/search_page";
        return await httpRequest.post<IPage<ICaseDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/case/search_one/${id}`;
        return await httpRequest.get<ICaseDetail>(apiUrl);
    }
    async insert(insertVo: ICaseDetail) {
        const apiUrl = `/web/case/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ICaseDetail) {
        const apiUrl = `/web/case/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(ids: ids) {
        const apiUrl = `/web/case/delete`;
        return await httpRequest.post<boolean>(apiUrl,ids);
    }
    //在线翻译
    async translation(params: ICaseDetail) {
        const apiUrl = `/web/case/translation`;
        return await httpRequest.post<ICaseDetail>(apiUrl, params);
    }
}
export const caseService = new CaseService();
